import { Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSTextField from "../../Components/TextBox/WSTextBox";
import WSPhone from "../../Components/Phone/WSPhone";
import { useFormContext } from "react-hook-form";
import WSSelectField from "../../Components/Select/WSSelect";

export const Address: React.FC<any> = React.memo((props) => {
  const { register, control } = useFormContext();

  return (
    <Grid container spacing={2}>
      {/* First Line: Address 1, City, and Search Button wrapped in a container */}
      <Grid container item xs={12} spacing={2}>
        {/* Address 1 */}
        <Grid item xs={12} sm={2}>
          <Typography>Address 1</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            label={""}
            {...register("address1")}
            id="address1"
            name="address1"
            control={control}
            rules={{ required: false }}
          />
        </Grid>

        {/* City */}
        <Grid item xs={12} sm={2}>
          <Typography>City</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            label={""}
            {...register("city")}
            id="city"
            name="city"
            control={control}
            rules={{ required: false }}
          />
        </Grid>

        {/* Search Button */}
        <Grid item xs={12} sm={2}>
          <IconButton>
            <WSIcons.SearchIcon />
          </IconButton>
        </Grid>
      </Grid>

      {/* Second Line: Address 2, State */}
      <Grid container item xs={12} spacing={2}>
        {/* Address 2 */}
        <Grid item xs={12} sm={2}>
          <Typography>Address 2</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            label={""}
            {...register("address2")}
            id="address2"
            name="address2"
            control={control}
            rules={{ required: false }}
          />
        </Grid>

        {/* State */}
        <Grid item xs={12} sm={2}>
          <Typography>State</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            label={""}
            {...register("state")}
            id="state"
            name="state"
            control={control}
            rules={{ required: false }}
          />
        </Grid>
      </Grid>

      {/* Third Line: Delivery Zone, Country */}
      <Grid container item xs={12} spacing={2}>
        {/* Delivery Zone */}
        <Grid item xs={12} sm={2}>
          <Typography>Delivery Zone</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSSelectField
            rules={{ required: true }}
            {...register("deliveryzone")}
            id="deliveryzone"
            control={control}
            defaultValue={"0"}
            label=""
            name="deliveryzone"
          />
        </Grid>

        {/* Country */}
        <Grid item xs={12} sm={2}>
          <Typography>Country</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSSelectField
            rules={{ required: true }}
            {...register("country")}
            id="country"
            control={control}
            defaultValue={"0"}
            label=""
            name="country"
          />
        </Grid>
      </Grid>

      {/* Fourth Line: Delivery Charges, Zip */}
      <Grid container item xs={12} spacing={2}>
        {/* Delivery Charges */}
        <Grid item xs={12} sm={2}>
          <Typography>Delivery Charges</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            label={""}
            {...register("deliverycharge")}
            id="deliverycharge"
            name="deliverycharge"
            control={control}
            rules={{ required: false }}
          />
        </Grid>

        {/* Zip */}
        <Grid item xs={12} sm={2}>
          <Typography>Zip</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            label={""}
            {...register("zip")}
            id="zip"
            name="zip"
            control={control}
            rules={{ required: false }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
});
